<template>
    <el-form class="add-ward-group-form" ref="addWardGroupForm" :model="form" label-position="top" v-loading="isLoading" :rules="form.rules">
        <el-row>
            <el-col :span="24">
                <el-form-item label="Dept Name:" prop="name">
                    <el-input class="name" v-model="form.name" placeholder="Enter the dept name"></el-input>
                </el-form-item>
            </el-col>
        </el-row>
    </el-form>
</template>

<script>
import { postData as addWardGroup } from "@/modules/settings/ward-group";
export default {
    name: "AddWardGroupForm",
    props: ["isLoading"],
    components: {},
    data() {
        return {
            form: {
                rules: {
                    name: [
                        {
                            required: true,
                            message: "Please enter a dept name",
                            trigger: ["blur", "change"],
                        },
                    ],
                },
                name: "",
            },
        };
    },
    methods: {
        async addWardGroup() {
            const valid = await this.validateForm();
            if (!valid) {
                return false;
            }
            try {
                let ward = {
                    name: this.form.name,
                };
                const result = await addWardGroup(ward);
                if (result) {
                    return ward.name;
                } else {
                    return result;
                }
            } catch (error) {
                console.log(error);
            }
        },
        async validateForm() {
            try {
                const result = await this.$refs.addWardGroupForm.validate();
                return result;
            } catch (error) {
                return false;
            }
        },
        resetForm() {
            this.$refs.addWardGroupForm.resetFields();
        },
    },
};
</script>
